"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React from "react"
import GroupCard from "../../../pages/homePageGroupSearch/GroupCard"
import EmblaCarousel from "./shared/EmblaCarousel"
import SectionContainer from "../shared/SectionContainer"
import Header from "../shared/Header"
import PrimaryAndSecondaryButtonsContainer from "../shared/PrimaryAndSecondaryButtonsContainer"
import useRedirectToLeaderOnboarding from "../../../../hooks/useRedirectToLeaderOnboarding"

import {
  PRIMARY_YELLOW_BUTTON_TYPE,
  SECONDARY_BUTTON_TYPE,
} from "../shared/constants"

function DiscoverGroups({ upcomingGroups }) {
  const [
    { isLoggedIn },
    { getRouteForLeaderOnboarding, getMonthlyListingsClickHandler },
  ] = useRedirectToLeaderOnboarding()
  const renderHeader = () => {
    return <Header text="Discover groups to join or refer others to" />
  }
  const renderButtons = () => {
    return (
      <PrimaryAndSecondaryButtonsContainer
        button1={{
          type: PRIMARY_YELLOW_BUTTON_TYPE,
          text: "Post your group",
          href: getRouteForLeaderOnboarding(),
        }}
        button2={{
          type: SECONDARY_BUTTON_TYPE,
          text: "Get monthly listings",
          onClick: async () => {
            getMonthlyListingsClickHandler()
          },
        }}
      />
    )
  }

  const renderGroupCards = () => {
    return (
      <EmblaCarousel
        slides={upcomingGroups.map(
          (
            {
              city,
              cohortNextStartsAt,
              cohortId,
              cohortLocations,
              groupDescription,
              groupId,
              groupName,
              groupPhotoUrl,
              groupType,
              joinableCohortCount,
              priceType,
              priceValue,
              providerFirstName,
              providerLastName,
              providerPhotoUrl,
              providerPreferredFirstName,
              providerPreferredLastName,
              providerPrimaryCredential,
              providerPrimaryRole,
              providerTitle,
              settingInPerson,
              settingVirtual,
              state,
            },
            index,
          ) => (
            <GroupCard
              city={city}
              cohortLocations={cohortLocations}
              cohortNextStartsAt={cohortNextStartsAt}
              cohortId={cohortId}
              groupDescription={groupDescription}
              groupId={groupId}
              groupName={groupName}
              groupPhotoUrl={groupPhotoUrl}
              groupType={groupType}
              joinableCohortCount={joinableCohortCount}
              priceType={priceType}
              priceValue={priceValue}
              providerFirstName={providerFirstName}
              providerLastName={providerLastName}
              providerPhotoUrl={providerPhotoUrl}
              providerPreferredFirstName={providerPreferredFirstName}
              providerPreferredLastName={providerPreferredLastName}
              providerPrimaryCredential={providerPrimaryCredential}
              providerPrimaryRole={providerPrimaryRole}
              providerTitle={providerTitle}
              settingInPerson={settingInPerson}
              settingVirtual={settingVirtual}
              state={state}
              index={index}
            />
          ),
        )}
      />
    )
  }

  return (
    <SectionContainer color="blue">
      {renderHeader()}
      {renderGroupCards()}
      {renderButtons()}
    </SectionContainer>
  )
}
export default DiscoverGroups
